// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type Options,
} from "@hey-api/client-fetch";
import type {
  GetLoginPrefillData,
  GetLoginPrefillError,
  GetLoginPrefillResponse,
  GetPublicCapacityData,
  GetPublicCapacityError,
  GetPublicCapacityResponse,
  GetPublicOrganizationPathByClientIdData,
  GetPublicOrganizationPathByClientIdError,
  GetPublicOrganizationPathByClientIdResponse,
} from "./types.gen";

export const client = createClient(createConfig());

export const getPublicOrganizationPathByClientId = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetPublicOrganizationPathByClientIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPublicOrganizationPathByClientIdResponse,
    GetPublicOrganizationPathByClientIdError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/orgPath",
  });
};

export const getLoginPrefill = <ThrowOnError extends boolean = false>(
  options: Options<GetLoginPrefillData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetLoginPrefillResponse,
    GetLoginPrefillError,
    ThrowOnError
  >({
    ...options,
    url: "/login_prefill/{token}",
  });
};

export const getPublicCapacity = <ThrowOnError extends boolean = false>(
  options: Options<GetPublicCapacityData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPublicCapacityResponse,
    GetPublicCapacityError,
    ThrowOnError
  >({
    ...options,
    url: "/capacities/availability",
  });
};
